export default () => ({
  influencer__name: {
    paddingTop: 6,
    paddingBottom: 6,
    fontSize: '20px',
  },
});
